import { Component, OnDestroy, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';
import { Subscription } from 'rxjs';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-changehistory-popup',
  templateUrl: './changehistory-popup.component.html',
  styleUrls: ['./changehistory-popup.component.scss'],
  standalone: false,
})
export class ChangeHistoryPopupComponent implements OnDestroy {
  @ViewChild('popup', { static: false }) popup: DxPopupComponent;

  dataSource: any[] = [];
  onClose: (e) => void;

  subscription_get_PopupAsObservable: Subscription;

  constructor(private popupService: PopupService) {
    this.onClickClose = this.onClickClose.bind(this);

    this.subscription_get_PopupAsObservable = this.popupService.get_changeHistoryPopupAsObservable.subscribe((context) => {
      if (context !== null && context !== undefined && context.open === true) {
        this.onClose = context.closeCb;
        this.dataSource = context.data ? [context.data] : [];
        this.popup.instance.show();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_get_PopupAsObservable) {
      this.subscription_get_PopupAsObservable.unsubscribe();
    }
  }

  onClickClose(e) {
    if (this.onClose !== undefined && this.onClose !== null) {
      this.onClose(3);
    }
    this.popup.instance.hide();
  }
}
